import {
  renderCellExpand,
  renderCellBoolean,
  renderCellTreeView,
  renderCellEncoder,
  renderCellDate,
  renderCellAiCaptions,
  renderCellList,
  renderCellStatus,
  renderCellPlayerActions,
} from './GridCellExpand'

const columnTypes = {
  title: {
    field: 'title',
    headerName: 'Title',
    width: 500,
    hide: false,
  },
  eventStatus: {
    field: 'eventStatus',
    headerName: 'Status',
    width: 100,
    hide: false,
    renderCell: renderCellStatus
  },
  startDateTime: {
    field: 'startDateTime',
    headerName: 'Start Date',
    width: 150,
    hide: false,
    renderCell: renderCellDate,
  },
  description: {
    field: 'description',
    headerName: 'Description',
    width: 250,
    hide: false,
    renderCell: renderCellExpand,
  },
  encoderID: {
    field: 'encoderID',
    headerName: 'Encoder ID',
    width: 110,
    hide: true,
  },
  eventID: {
    field: 'eventID',
    headerName: 'Event ID',
    width: 110,
    hide: true,
  },
  customID: {
    field: 'customID',
    headerName: 'Custom ID',
    width: 110,
    hide: true,
  },
  assetCount: {
    field: 'assetCount',
    headerName: '# Assets',
    width: 85,
    hide: true,
  },
  autoStart: {
    field: 'autoStart',
    headerName: 'Auto Start?',
    width: 85,
    renderCell: renderCellBoolean,
    hide: true,
  },
  autoStop: {
    field: 'autoStop',
    headerName: 'Auto Stop?',
    width: 85,
    renderCell: renderCellBoolean,
    hide: true,
  },
  categories: {
    field: 'categories',
    headerName: 'Categories',
    width: 125,
    hide: true,
    renderCell: renderCellList
  },
  chat: {
    field: 'chat',
    headerName: 'Chat?',
    width: 85,
    renderCell: renderCellBoolean,
    hide: true,
  },
  customData: {
    field: 'customData',
    headerName: 'Custom Data',
    width: 200,
    renderCell: renderCellTreeView,
    hide: true,
  },
  encoderDetails: {
    field: 'encoderDetails',
    headerName: 'Encoder Details',
    width: 125,
    hide: true,
    renderCell: renderCellEncoder,
  },
  keywords: {
    field: 'keywords',
    headerName: 'Keywords',
    width: '125',
    hide: true,
    renderCell: renderCellList
  },
  liveAiCaptions: {
    field: 'liveAiCaptions',
    headerName: 'AI Captions',
    width: '100',
    hide: true,
    renderCell: renderCellAiCaptions,
  },
  locationName: {
    field: 'locationName',
    headerName: 'Location',
    width: 125,
    hide: true,
  },
  notes: {
    field: 'notes',
    headerName: 'Notes',
    width: 125,
    hide: true,
  },
  private: {
    field: 'private',
    headerName: 'Private?',
    width: 85,
    renderCell: renderCellBoolean,
    hide: true,
  },
  technicians: {
    field: 'technicians',
    headerName: 'Technicians',
    width: 125,
    hide: true,
  },
  eventActions: {
    field: 'eventActions',
    headerName: 'Actions',
    width: 150,
    renderCell: renderCellPlayerActions,
    hide: true
  }
}

export const getDefaultColumns = () => {
  const renderTypes = {}
  Object.keys(columnTypes).forEach(
    (col) => (renderTypes[col] = columnTypes[col])
  )
  return renderTypes
}
